import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";

const OrdenesVenta = () => {
    const [orders, setOrders] = useState([]);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const response = await apiClient.get("/sales-orders/differences");
            setOrders(response.data);
        } catch (err) {
            setError("Error al cargar las órdenes de venta.");
        }
    };

    const handleUpdatePrices = async (docEntry, lines) => {
        try {
            const updateData = {
                Orders: [
                    {
                        DocEntry: docEntry,
                        Lines: lines.map(line => ({
                            LineNum: line.LineNum,
                            Precio: line.Precio,
                            AgrNo: line.AgrNo,
                            GlobalPrice: line.GlobalPrice
                        }))
                    }
                ]
            };
    
            console.log("Enviando datos al backend:", updateData);
            const response = await apiClient.patch("/sales-orders/update-prices", updateData);
            setMessage(`Precios actualizados correctamente para DocEntry: ${docEntry}`);
            fetchOrders(); // Refrescar la tabla
        } catch (err) {
            setError("Error al actualizar precios."+err);
        }
    };

    const handleBulkUpdatePrices = async () => {
        try {
            if (!orders.length) {
                setError("No hay órdenes para actualizar.");
                return;
            }
    
            const updateData = {
                Orders: orders.map(order => ({
                    DocEntry: order.DocEntry,
                    Lines: order.Lines.map(line => ({
                        LineNum: line.LineNum,
                        Precio: line.Precio,
                        AgrNo: line.AgrNo,
                        GlobalPrice: line.GlobalPrice
                    }))
                }))
            };
    
            console.log("Enviando datos al backend:", updateData);
    
            const response = await apiClient.patch("/sales-orders/update-prices", updateData);
            setMessage("Precios actualizados correctamente para todas las órdenes.");
            fetchOrders(); // Recargar la tabla después de la actualización
        } catch (err) {
            setError("Error al actualizar precios de forma masiva: " + err);
            console.error(err);
        }
    };
    

    // Columnas del DataTable
    const columns = [
        {
            name: "DocEntry",
            selector: row => row.DocEntry,
            sortable: true,
        },
        {
            name: "DocNum",
            selector: row => row.DocNum,
            sortable: true,
        },
        {
            name: "Cliente",
            selector: row => row.CardName,
            sortable: true,
        },
        {
            name: "Acciones",
            cell: row => (
                <button 
                    className="btn btn-sm btn-primary"
                    onClick={() => handleUpdatePrices(row.DocEntry, row.Lines)}
                >
                    Actualizar Precios
                </button>
            ),
        },
    ];

    // Expandir líneas de la orden dentro del DataTable
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered">
                <thead>
                    <tr>
                        <th>ItemCode</th>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                        <th>Acuerdo Global</th>
                        <th>Precio Actual</th>
                        <th>Precio Sin IVA</th>
                        <th>Precio Global</th>
                        <th>Diferencia</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Lines.map((line, index) => (
                        <tr key={index}>
                            <td>{line.ItemCode}</td>
                            <td>{line.Dscription}</td>
                            <td>{line.Quantity}</td>
                            <td>{line.AgrNo}</td>
                            <td>{line.Price}</td>
                            <td>{line.Precio}</td>
                            <td>{line.GlobalPrice}</td>
                            <td style={{ color: line.PriceDifference < 0 ? "red" : "green" }}>
                                {line.PriceDifference}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    return (
        <div className="container mt-4">
            <h2>Órdenes de Venta con Diferencias de Precio</h2>

            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <DataTable
                columns={columns}
                data={orders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
                highlightOnHover
            />
            <button 
                className="btn btn-primary mt-3"
                onClick={handleBulkUpdatePrices}
            >
                Actualizar Precios Masivamente
            </button>

        </div>
    );
};

export default OrdenesVenta;
